export default __webpack_public_path__ + "assets/h4.9a7c93c7.svg";